import { createFileRoute } from '@tanstack/react-router';
import { PaymentMethodRepairPage } from '@/components/public/PaymentMethodRepairPage';
import type { PublicMembershipRepairContext } from '@/types/public';

export const Route = createFileRoute('/(public)/repair-membership/$token')({
  component: MembershipPaymentMethodRepairPage,
});

/** The membership's card repair page — the dunning emails' "Update payment method" button lands here. */
function MembershipPaymentMethodRepairPage() {
  const { token } = Route.useParams();
  return (
    <PaymentMethodRepairPage
      token={token}
      apiBase="/api/public/membership-repair"
      queryKey="membership-repair"
      describeSubject={(context) =>
        `your ${(context as PublicMembershipRepairContext).membershipPlanName} membership`
      }
    />
  );
}
